<template>
  <div>
    <hr>
    <a
      class="button is-primary"
      v-clipboard="() => hashedValues"
      v-clipboard:success="urlCopySuccess"
      v-clipboard:error="urlCopyFail"
    >
      <span class="icon">
        <i class="fas fa-link"></i>
      </span>
      <span>Copy link to this counter</span>
    </a>
  </div>
</template>

<script>
import helpers from '../utils/helpers.js';
import base64 from 'base-64';
import utf8 from 'utf8';

const BASE_URL = 'https://worth-while.org/counter/';

export default {
	props: ['formValues'],
	computed: {
		hashedValues: function() {
			let utf8String = utf8.encode(JSON.stringify(this.formValues));
			var encoded = base64.encode(utf8String);
			return BASE_URL + encoded;
		},
	},
	methods: {
		urlCopySuccess: function() {
			this.$snackbar.open(`URL copied to clipboard.`);
		},
		urlCopyFail: function() {
			this.$snackbar.open({
				duration: 5000,
				message: 'Sorry, there was an error copying the URL :(',
				type: 'is-danger',
			});
		},
	},
};
</script>

<style scoped>
</style>
